import "./src/styles/global.css"
import { rootWrapper } from "./src/root-wrapper";

export const wrapPageElement = rootWrapper;
